<script>
import SelectWithSearch from "@/views/pages/Dilfoods/Common/SelectWithSearch";
import { CityPath } from "@/path.js";
import { RestaurantsPath, USERSPATH } from "../../../../../path";
import axios from "axios";
import Swal from "sweetalert2";
export default {
  props: ["selectedUser"],
  name: "add",
  data() {
    return {
      base_url: process.env.VUE_APP_API_BACKEND_URL,
      restaurants: [],
      currentPage: 1,
      search: "",
      department: "",
      account_type: "",

      roles: [],
      permissions: [],
      cities: [],
      form: {
        roles: [],
        mobile_number: null,
        city: null,
        restaurant_ids: [],
        s_restaurant_ids: [],
      },
      filter: [],
      key: 1,
      show_mapped: true,
    };
  },
  computed: {
    CityPath() {
      return CityPath;
    },
    selectedRoleNames() {
      if (!this.form.roles || !this.form.roles.length || !this.roles.length) return [];
      return this.roles
        .filter((r) => this.form.roles.some((id) => id == r.id))
        .map((r) => r.name);
    },
    isAccountManager() {
      return this.selectedRoleNames.includes("AccountManagers");
    },
    isChef() {
      return this.selectedRoleNames.includes("Chefs");
    },
    tableFields() {
      const base = ["name", "city", { key: "edit", label: "Primary" }];
      if (this.isAccountManager) {
        base.push({ key: "s_am_id", label: "Secondary" });
      }
      return base;
    },
  },
  components: {
    "select-with-search": SelectWithSearch,
  },
  watch: {
    currentPage() {
      this.getRestaurants();
    },
    search() {
      this.getRestaurants();
    },
    "form.roles"() {
      this.key += 1;
    },
    show_mapped() {
      // Clear unsaved changes by resetting from the original user data
      if (this.selectedUser && this.selectedUser.id) {
        if (
          this.selectedUser.roles != undefined &&
          this.selectedUser.roles.length > 0
        ) {
          const roleIds = this.selectedUser.roles.map((r) => r.id);
          if (roleIds.includes(4)) {
            this.form.restaurant_ids =
              this.selectedUser.am_restaurants?.map((r) => r.id) || [];
          } else if (roleIds.includes(5)) {
            this.form.restaurant_ids =
              this.selectedUser.ac_restaurants?.map((r) => r.id) || [];
          }
          this.form.s_restaurant_ids =
            this.selectedUser.s_am_restaurants?.map((r) => r.id) || [];
        }
      }
      this.getRestaurants();
    },
  },
  methods: {
    async getRestaurants() {
      try {
        let params = {
          page: this.currentPage,
          search: this.search,
          city: this.form.city,
        };
        if (this.show_mapped && this.selectedUser && this.selectedUser.id) {
          params.mapped_to = this.selectedUser.id;
        }
        let response = await axios.get(
          this.base_url + RestaurantsPath.BASIC_RESTAURENT,
          { params }
        );
        if (response.data.status == true) {
          this.restaurants = response.data.data;
        }
      } catch (e) {
        console.log(e);
      }
    },
    async getPermissions() {
      try {
        let res = await axios.get(this.base_url + USERSPATH.GET_PERMISSIOINS);
        if (res.data.status) {
          this.permissions = res.data.data;
        }
      } catch (error) {
        console.log(error);
      }
    },
    async getRoles() {
      try {
        let res = await axios.get(this.base_url + USERSPATH.GET_ROLES);
        if (res.data.status) {
          this.roles = res.data.data;
        }
      } catch (error) {
        console.log(error);
      }
    },
    async getCities() {
      try {
        let res = await axios.get(this.base_url + CityPath.GET_CITY);
        if (res.data.data) {
          this.cities = res.data.data;
          if (this.selectedUser && this.selectedUser.city) {
            let matchedCity = this.cities.find(
              (c) => c.id == this.selectedUser.city
            );
            if (matchedCity) {
              this.form.city = matchedCity.city;
            } else if (isNaN(this.selectedUser.city)) {
              this.form.city = this.selectedUser.city;
            }
          }
        }
      } catch (err) {
        console.log(err);
      }
    },
    setRoles(v) {
      this.form.roles = Array.isArray(v) ? v : v != null ? [v] : [];
    },
    addRestaurant(v) {
      if (
        this.form.restaurant_ids != undefined &&
        this.form.restaurant_ids.length > 0
      ) {
        if (this.form.restaurant_ids.filter((f) => f == v.id).length == 0) {
          this.form.restaurant_ids.push(v.id);
        }
      } else {
        this.form.restaurant_ids = [v.id];
      }
      this.key += 1;
    },
    removeRestaurant(v) {
      if (this.form.restaurant_ids && this.form.restaurant_ids.length > 0) {
        this.form.restaurant_ids = this.form.restaurant_ids.filter(
          (f) => f != v.id
        );
      }
      this.key += 1;
    },
    addSRestaurant(v) {
      if (
        this.form.s_restaurant_ids != undefined &&
        this.form.s_restaurant_ids.length > 0
      ) {
        if (this.form.s_restaurant_ids.filter((f) => f == v.id).length == 0) {
          this.form.s_restaurant_ids.push(v.id);
        }
      } else {
        this.form.s_restaurant_ids = [v.id];
      }
      this.key += 1;
    },
    removeSRestaurant(v) {
      if (this.form.s_restaurant_ids && this.form.s_restaurant_ids.length > 0) {
        this.form.s_restaurant_ids = this.form.s_restaurant_ids.filter(
          (f) => f != v.id
        );
      }
      this.key += 1;
    },
    async saveUser() {
      try {
        if (this.selectedUser) {
          this.form.id = this.selectedUser.id;
        }
        let res = await axios.post(
          this.base_url + USERSPATH.SAVE_USER,
          this.form
        );
        if (res.data.status) {
          Swal.fire("Success", "", "success");
          this.$emit("update");
        } else {
          throw new Error(res.data.message);
        }
      } catch (error) {
        console.log(error);
        Swal.fire(error, "", "error");
      }
    },
  },
  async mounted() {
    await this.getPermissions();
    await this.getRoles();
    await this.getCities();

    if (this.selectedUser && this.selectedUser.id) {
      if (
        this.selectedUser.roles != undefined &&
        this.selectedUser.roles.length > 0
      ) {
        const roleIds = this.selectedUser.roles.map((r) => r.id);
        if (roleIds.includes(4)) {
          this.form.restaurant_ids =
            this.selectedUser.am_restaurants?.map((r) => r.id) || [];
        } else if (roleIds.includes(5)) {
          this.form.restaurant_ids =
            this.selectedUser.ac_restaurants?.map((r) => r.id) || [];
        }
        this.form.s_restaurant_ids =
          this.selectedUser.s_am_restaurants?.map((r) => r.id) || [];
        this.form.roles = roleIds;
      } else {
        this.form.restaurant_ids = [];
        this.form.s_restaurant_ids = [];
      }
      this.form.name = this.selectedUser.name;
      this.form.email = this.selectedUser.email;
      this.form.mobile_number = this.selectedUser.mobile_number;
      this.key += 1; // Force re-render once mappings are loaded
    }

    await this.getRestaurants();
  },
};
</script>

<template>
  <div class="row">
    <div class="col-sm-12 col-md-12">
      <b-tabs pills card>
        <b-tab title="User Details" active>
          <b-container fluid="sm">
            <b-row class="my-1">
              <b-col sm="6">
                <label>Name:</label>
                <b-form-input
                  id="input-small"
                  v-model="form.name"
                  size="sm"
                  placeholder="Enter your name"
                ></b-form-input>
              </b-col>
              <b-col sm="6">
                <label>Email:</label>
                <b-form-input
                  id="input-small"
                  v-model="form.email"
                  size="sm"
                  placeholder="Enter Email"
                ></b-form-input>
              </b-col>
              <b-col sm="6">
                <label>Mobile Number:</label>
                <b-form-input
                  id="input-small"
                  v-model="form.mobile_number"
                  size="sm"
                  type="text"
                  placeholder="Enter Mobile Number"
                ></b-form-input>
              </b-col>
              <b-col sm="6">
                <label>Password: (leave Empty not to change)</label>
                <b-form-input
                  id="input-small"
                  v-model="form.password"
                  size="sm"
                  placeholder="Enter Password"
                ></b-form-input>
              </b-col>
            </b-row>
            <b-row class="my-1">
              <b-col sm="6">
                <label>Role:</label>
                <select-with-search
                  :search_without_api="true"
                  track_by="id"
                  display="name"
                  :selected_data="form.roles"
                  selected_by="id"
                  :optionsData="roles"
                  :multi_select="true"
                  @selectedOption="setRoles"
                ></select-with-search>
              </b-col>
              <b-col sm="6">
                <label>City:</label>
                <select-with-search
                  :key="cities.length + (form.city || '')"
                  :search_without_api="true"
                  :optionsData="cities"
                  track_by="city"
                  display="city"
                  :selected_data="[form.city]"
                  selected_by="city"
                  :send_null="true"
                  @selectedOption="(v) => (form.city = v)"
                ></select-with-search>
              </b-col>
            </b-row>
            <b-row class="my-1">
              <!-- <b-col sm="6" v-if="permissions.length > 0">
                <label>Permission:</label>
                <select-with-search                  
                  :search_without_api="true"
                  track_by="id"                  
                  display="name"
                  selected_by="id"
                  :selected_data="form.permissions"
                  :optionsData="permissions"           
                  :multi_select="true"       
                  @selectedOption="(v) => (form.permissions = v)"
                ></select-with-search>
              </b-col> -->
            </b-row>
            <b-row class="my-1 mt-2">
              <b-col sm="12">
                <b-button @click="saveUser" class="btn btn-success"
                  >Submit</b-button
                >
              </b-col>
            </b-row>
          </b-container>
        </b-tab>
        <b-tab
          title="Map Restaurants"
          @click="getRestaurants"
          v-if="isAccountManager || isChef"
        >
          <b-container fluid="sm">
            <div class="col-sm-12 col-md-12">
              <div
                id="tickets-table_filter"
                class="dataTables_filter text-md-right d-flex align-items-center justify-content-between w-100"
              >
                <b-nav pills class="mb-0">
                  <b-nav-item :active="show_mapped" @click="show_mapped = true">Mapped</b-nav-item>
                  <b-nav-item :active="!show_mapped" @click="show_mapped = false">Unmapped</b-nav-item>
                </b-nav>

                <label class="d-inline-flex align-items-center mr-5 mb-0">
                  Search:
                  <b-form-input
                    v-model="search"
                    type="search"
                    debounce="300"
                    class="form-control form-control-sm ml-2"
                  ></b-form-input>
                </label>
              </div>
            </div>
            <div class="table-responsive mb-0">
              <b-table
                :key="restaurants.key + (key * 100)"
                :items="restaurants.data"
                :fields="tableFields"
                responsive="sm"
                :filter="filter"
                :current-page="currentPage"
              >
                <template v-slot:cell(s_am_id)="row">
                  <div :key="key + 2">
                    <!-- Disabled: this user is already the primary AM in DB or in current selection -->
                    <span
                      v-if="selectedUser && (Number(row.item.am_id) == Number(selectedUser.id) || (form.restaurant_ids && form.restaurant_ids.some(f => Number(f) == Number(row.item.id))))"
                      class="badge badge-secondary"
                      v-b-tooltip.hover
                      title="This user is already mapped as Primary AM for this restaurant"
                    >
                      <i class="fa fa-lock mr-1"></i> Primary AM
                    </span>
                    <template v-else>
                      <b-button
                        variant="success"
                        v-if="!form.s_restaurant_ids || !form.s_restaurant_ids.some(f => Number(f) == Number(row.item.id))"
                        @click="addSRestaurant(row.item)"
                        >+</b-button
                      >
                      <b-button
                        variant="danger"
                        v-else
                        @click="removeSRestaurant(row.item)"
                        >-</b-button
                      >
                    </template>
                  </div>
                </template>
                <template v-slot:cell(edit)="row">
                  <div :key="key + 1">
                    <!-- Disabled: this user is already the secondary AM in DB or in current selection -->
                    <span
                      v-if="selectedUser && (Number(row.item.s_am_id) == Number(selectedUser.id) || (form.s_restaurant_ids && form.s_restaurant_ids.some(f => Number(f) == Number(row.item.id))))"
                      class="badge badge-secondary"
                      v-b-tooltip.hover
                      title="This user is already mapped as Secondary AM for this restaurant"
                    >
                      <i class="fa fa-lock mr-1"></i> Secondary AM
                    </span>
                    <template v-else>
                      <b-button
                        variant="success"
                        v-if="!form.restaurant_ids || !form.restaurant_ids.some(f => Number(f) == Number(row.item.id))"
                        @click="addRestaurant(row.item)"
                        >+</b-button
                      >
                      <b-button
                        variant="danger"
                        v-else
                        @click="removeRestaurant(row.item)"
                        >-</b-button
                      >
                    </template>
                  </div>
                </template>
              </b-table>
            </div>
            <div class="row">
              <div class="col">
                <div
                  class="dataTables_paginate paging_simple_numbers float-right"
                >
                  <ul class="pagination pagination-rounded mb-0">
                    <!-- pagination -->
                    <b-pagination
                      :key="restaurants.key"
                      v-model="currentPage"
                      :total-rows="restaurants.total"
                      :per-page="restaurants.per_page"
                    ></b-pagination>
                  </ul>
                </div>
              </div>
            </div>
            <b-row class="my-1 mt-2">
              <b-col sm="12">
                <b-button @click="saveUser" class="btn btn-success"
                  >Submit</b-button
                >
              </b-col>
            </b-row>
          </b-container>
        </b-tab>
      </b-tabs>
    </div>
  </div>
</template>

<style></style>
